import helperFunctions from "./helper-functions";
import meetingGuestModel from "@/store/orm-axios/models/MeetingGuest";
let eventSource;

const meetingGuestIRI = "/meeting_guests/";

export default {
  computed: {
    mercureJwtToken() {
      return this.$store.getters["auth/mercureJwtToken"];
    },
  },
  watch: {
    mercureJwtToken(oldValue, newValue) {
      if (oldValue.length != 0 && newValue.length != 0) {
        this.initMeetingGuestMercure();
      }
    },
  },
  mounted() {
    this.initMeetingGuestMercure();
  },
  beforeDestroy() {
    eventSource.close();
  },
  methods: {
    initMeetingGuestMercure() {
      if (eventSource) eventSource.close();

      const topics = [`${meetingGuestIRI}{id}`];

      eventSource = helperFunctions.getEventSource(topics);

      eventSource.onmessage = event => {
        const eventData = JSON.parse(event.data);

        var model = null;
        if (eventData["@id"].includes(meetingGuestIRI)) {
          model = meetingGuestModel;
        }

        helperFunctions.modifyInStore(eventData, model);
      };

      helperFunctions.case401Error(eventSource);
    },
  },
};
